import React, {
	Suspense
} from 'react';
import {
	Routes,
	BrowserRouter as Router,
	Route,
	Outlet
} from 'react-router-dom';
import {
	Loader,
	ScrollToTop,
	PageNotFound,
	AuthRequired,
	HeadMeta,
	HeaderScrollBanner,
	FooterFixedBanner,
	Modals,
	RSnackBar,
	LiveCaller,
	// CaptchaBadge,
	// Feedback,
	MainLayout,
	// FeedbackHome
} from 'components';
import {
	UserProvider,
	AppDataProvider,
	HistoryProvider,
	SyncProvider,
	BannersProvider,
	ModalsProvider,
	ToastsProvider,
	Ga4Provider
	// CaptchaProvider
} from 'contexts';
import {
	RouteList
} from 'modules';


import { constructor } from 'services';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { growthbook } from './libs/growthbook';
import { useInitGrowthbook } from './libs/hooks/useInitGrowthbook';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const App = () => {
	const build = constructor();

	const PrivateRoute = () => (
		build.processUser() ? <Outlet /> : <AuthRequired {...build.data} />
	)

  useInitGrowthbook()

	return !build.data ? <Loader /> :
		<Router>
      <GrowthBookProvider growthbook={growthbook}>
			  <AppDataProvider {...build.data}>
          <HistoryProvider {...{RouteList}}>
            <HeadMeta {...build.data}/>
            <Ga4Provider>
            <UserProvider {...build.data}>
              <SyncProvider {...build.data}>
                <QueryClientProvider client={queryClient}>
                  <BannersProvider {...build.data}>
                    <ModalsProvider>
                      <ToastsProvider>
                        {/* <CaptchaBadge /> */}
                        <ScrollToTop />
                        <HeaderScrollBanner {...build.data}/>
                        {/*<Header {...build.data} />*/}

                          <Routes>
                            {RouteList.map((config, i) => {
                              const Layout = config.Layout ? config.Layout : MainLayout
                              config.path = build.processPath(config.path);
                              return config.private ?
                                <Route element={<PrivateRoute/>} key={i}>
                                  <Route {...config} element={
                                    <Layout {...build.data}>
                                      <Suspense fallback={<Loader />}>
                                        <config.Component {...build.data}/>
                                      </Suspense>
                                    </Layout>
                                  }/>
                                </Route>
                              :
                                <Route {...config} key={i} element={
                                  <Layout {...build.data}>
                                    <Suspense fallback={<Loader />}>
                                      <config.Component {...build.data}/>
                                    </Suspense>
                                  </Layout>
                                } />
                            })}
                            <Route path="*" element={<MainLayout {...build.data}><PageNotFound {...build.data}/></MainLayout>} />
                          </Routes>

                        {/*<Footer {...build.data} />*/}
                        <Modals />
                        <RSnackBar />
                        <LiveCaller {...build.data} />
                        <FooterFixedBanner/>
                         {/* <Feedback/> */}
                        {/*<OffersPolicyModal {...build.data} />*/}
                        {/*<DataSharingConsentModal {...build.data} />*/}
                      </ToastsProvider>
                    </ModalsProvider>
                  </BannersProvider>
                </QueryClientProvider>
              </SyncProvider>
            </UserProvider>
            </Ga4Provider>
          </HistoryProvider>
			  </AppDataProvider>
      </GrowthBookProvider>
		</Router>
};

export default App

//